import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import SearchHomepage from "../SearchHomepage";
import SearchByGenes from "../SearchByGenes";
import css from "../Homepage.module.css";

const PanelHP = () => {
  const [key, setKey] = useState("pathways");

  return (
    <div className={css.tabContainer}>
      <Tabs activeKey={key} onSelect={(k) => setKey(k)} fill>
        <Tab
          eventKey="pathways"
          title="Search by Pathways"
          className={css.singleTab}
        >
          <SearchHomepage />
        </Tab>
        <Tab eventKey="genes" title="Search by Genes" className={css.singleTab}>
          <SearchByGenes />
        </Tab>
      </Tabs>
    </div>
  );
};

export default PanelHP;
